module.exports = __webpack_public_path__ + "static/media/dislike.459229ff.png";